// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.password-strength {
   display: block;
}
.text {
   font-size: 12px;
   justify-content: space-between;
}
.error {
   font-size: 12px;
   margin-bottom: 10px;
}
.meter {
   margin: 0 -.5%;
}
.meter div {
   background-color: #555;
   float: left;
   height: 3px;
   width: 19%;
   margin: 0 .5%;
   transition: background-color .4s;
}
.meter .l0 {
   background-color: #c00;
}
.meter .l1 {
   background-color: #F56600;
}
.meter .l2 {
   background-color: #fc0;
}
.meter .l3 {
   background-color: #85CC00;
}
.meter .l4 {
   background-color: #0c0;
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/password-strength/password-strength.css"],"names":[],"mappings":"AAAA;GACG,cAAc;AACjB;AACA;GACG,eAAe;GACf,8BAA8B;AACjC;AACA;GACG,eAAe;GACf,mBAAmB;AACtB;AACA;GACG,cAAc;AACjB;AACA;GACG,sBAAsB;GACtB,WAAW;GACX,WAAW;GACX,UAAU;GACV,aAAa;GACb,gCAAgC;AACnC;AACA;GACG,sBAAsB;AACzB;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,sBAAsB;AACzB;AACA;GACG,yBAAyB;AAC5B;AACA;GACG,sBAAsB;AACzB","sourcesContent":[".password-strength {\n   display: block;\n}\n.text {\n   font-size: 12px;\n   justify-content: space-between;\n}\n.error {\n   font-size: 12px;\n   margin-bottom: 10px;\n}\n.meter {\n   margin: 0 -.5%;\n}\n.meter div {\n   background-color: #555;\n   float: left;\n   height: 3px;\n   width: 19%;\n   margin: 0 .5%;\n   transition: background-color .4s;\n}\n.meter .l0 {\n   background-color: #c00;\n}\n.meter .l1 {\n   background-color: #F56600;\n}\n.meter .l2 {\n   background-color: #fc0;\n}\n.meter .l3 {\n   background-color: #85CC00;\n}\n.meter .l4 {\n   background-color: #0c0;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
